const organization_details = {
    departments: {
        leader: '責任者',
        leaders: '部門責任者',
        led_departments: '担当部門',
        edit_leaders: '責任者を設定',
        add_leader: '追加',
        remove_leader: '削除',
        no_leaders: '責任者未設定',
        local: 'ローカル設定',
        managed_members: '管理範囲のメンバー',
        leader_scope_hint: '担当部門とその配下の部門の所属を管理できます。',
        leader_permission_hint: '責任者は担当部門と配下の所属を管理でき、組織ロールや部門構造は変更できません。',
        primary_synced: '主所属部門はFeishuで管理されます。',
        status_active: '在籍',
        status_suspended: '停止中',
        status_departed: '退職',
        status_pending: '有効化待ち',
        search: '検索',
        previous_page: '前のページ',
        next_page: '次のページ',
        directory_title: '組織のメンバー',
        member_name: 'メンバー',
        search_members: '氏名またはユーザー名で検索',
        include_descendants: '下位部署を含める',
        no_members: '該当するメンバーがいません。',
        all_members: 'すべてのメンバー',
        all_departments: 'すべての部署',
        edit_member: '所属部署を編集',
        add_child: '下位部署を追加',
        expand_department: '{{name}}を展開',
        collapse_department: '{{name}}を折りたたむ',
        title: '部署',
        description: 'この組織の部署とメンバーの所属を管理します。',
        create: '部署を作成',
        edit: '部署を編集',
        name: '部署名',
        parent: '親部署',
        root: '親部署なし',
        id: '部署 ID',
        members: 'メンバーの所属部署',
        member_id: 'メンバーのユーザー ID',
        primary: '主所属部署',
        none: '未設定',
        assignments: '部署の所属一覧',
        no_assignments: '部署の所属はまだありません。',
        assignment_hint: 'ローカル部署と任意の主所属部署を指定します。ディレクトリ管理の所属は読み取り専用です。',
        empty: '部署はまだありません。',
        readonly: '部署と自分の所属を確認できます。変更は組織管理者にお問い合わせください。',
        load_error: 'データを読み込めませんでした。再試行してください。',
        mutation_error: '保存できませんでした。権限、組織への所属、部署の階層を確認してください。',
        loading: '読み込み中…',
        synced: 'ディレクトリ管理',
        choose: '部署を検索',
        organizations_title: '組織と部署',
        organizations_description: '組織を選択して部署を表示または管理します。',
        no_organizations: '組織に所属していません。組織管理者にお問い合わせください。',
        organization: '現在の組織',
        choose_organization: '組織を選択',
        delete_title: '部署を削除',
        delete_description: '「{{name}}」を削除しますか？先にメンバーと子部署を移動してください。',
    },
    directory: {
        leaders_label: '部門責任者の関係',
        local_department_leader: 'ローカル設定の部門責任者',
        status_active: '在籍',
        status_suspended: '停止中',
        status_departed: '退職',
        status_pending: '有効化待ち',
        profiles_label: '連携元プロフィール',
        primary_label: '主所属部門の変更',
        deactivated_label: '無効化する組織ID',
        reactivated_label: '再有効化する組織ID',
        lifecycle_notice: '保持するロール割り当て：{{count}} 件。再有効化すると以前の権限が復元されます。',
        title: 'Feishu ディレクトリ',
        description: 'Feishu コネクターを使い、この組織に部署とメンバーをインポートします。',
        identity_notice: 'ディレクトリプロビジョニングを有効にしたコネクターを使用してください。既存コネクターの識別方式を変更するにはアカウントの移行が必要です。',
        connector: 'Feishu コネクター ID',
        preview: '同期をプレビュー',
        preview_title: '同期プレビュー',
        preview_description: 'インポート前に内容を確認してください。変更された場合は再度プレビューしてください。',
        import: '同期を確定',
        success: '{{departments}} 部署と {{users}} メンバーをインポートし、{{createdUsers}} アカウントを作成しました。 {{removedDepartments}} 部署、{{removedMemberships}} 件のメンバーシップ、{{removedAssignments}} 件の所属を削除しました。',
        failure: '読み取りまたはインポートに失敗しました。コネクターの権限と公開範囲を確認し、再度プレビューしてください。',
        behavior_title: 'インポート方式',
        mode: '氏名、アバター、部門、主所属部門を同期します。不在または無効なメンバーは現在の組織へのアクセスのみ失います。ロール、ローカルの所属、グローバルアカウント、他の組織IDは保持します。メールと電話は連携元情報として保存し、ログイン認証情報には設定しません。',
        limits: '1 回につき部署 1000、ユーザー 5000、所属 10000 件まで。読み取りは 60 秒まで。不完全または上限超過のインポートは拒否します。',
        counts: '{{departments}} 部署 · {{users}} メンバー',
        departments_label: '部署',
        members_label: '組織メンバーシップ',
        assignments_label: '部署への所属',
        item: '項目',
        added: '追加',
        updated: '更新',
        removed: '削除',
        cleanup_notice: '氏名、アバター、部門、主所属部門を同期します。不在または無効なメンバーは現在の組織へのアクセスのみ失います。ロール、ローカルの所属、グローバルアカウント、他の組織IDは保持します。メールと電話は連携元情報として保存し、ログイン認証情報には設定しません。',
        conflicts_title: '{{count}} 件の競合により同期できません。ローカルの依存関係を解決し、再度プレビューしてください。',
        removals_title: '削除対象の例（カテゴリごとに最大 20 件）',
        local_child_department: 'ローカルの子部署',
        unowned_assignment: 'ローカルまたは同期元が不明な既存の所属',
        local_member_roles: 'メンバーにローカルで割り当てたロールがあります',
        unlinked_identity: 'ディレクトリ ID の連携が解除されています',
    },
    page_title: '組織の詳細',
    delete_confirmation: '削除すると、すべてのメンバーが組織内のメンバーシップとロールを失います。この操作は元に戻せません。',
    organization_id: '組織ID',
    settings_description: '組織は、アプリケーションにアクセスできるチーム、ビジネス顧客、およびパートナー企業を表します。',
    name_placeholder: '組織の名前。一意である必要はありません。',
    description_placeholder: '組織の説明。',
    member: 'メンバー',
    member_other: 'メンバー',
    add_members_to_organization: '組織 {{name}} にメンバーを追加',
    add_members_to_organization_description: '名前、メール、電話、またはユーザーIDで検索して適切なユーザーを見つけます。検索結果には既存のメンバーは表示されません。',
    add_with_organization_role: '組織の役割付きで追加',
    user: 'ユーザー',
    application: 'アプリケーション',
    application_other: 'アプリケーション',
    add_applications_to_organization: '組織 {{name}} にアプリケーションを追加',
    add_applications_to_organization_description: 'アプリID、名前、または説明を検索して適切なアプリケーションを見つけます。検索結果には既存のアプリケーションは表示されません。',
    at_least_one_application: '少なくとも1つのアプリケーションが必要です。',
    remove_application_from_organization: '組織からアプリケーションを削除',
    remove_application_from_organization_description: '削除されると、このアプリケーションは組織の関連付けとロールを失います。この操作は元に戻せません。',
    search_application_placeholder: 'アプリID、名前、または説明で検索',
    roles: '組織ロール',
    authorize_to_roles: '{{name}} に以下の役割へのアクセスを許可',
    edit_organization_roles: '組織の役割を編集',
    edit_organization_roles_title: '{{name}} の組織役割を編集',
    remove_user_from_organization: '組織からユーザーを削除',
    remove_user_from_organization_description: '削除すると、ユーザーは組織内のメンバーシップとロールを失います。この操作は元に戻せません。',
    search_user_placeholder: '名前、メール、電話番号、またはユーザーIDで検索',
    at_least_one_user: '少なくとも1人のユーザーが必要です。',
    organization_roles_tooltip: 'この組織内で {{type}} に割り当てられた役割。',
    custom_data: 'カスタムデータ',
    custom_data_tip: 'カスタムデータは、組織に関連付けられた追加データを格納するために使用できるJSONオブジェクトです。',
    invalid_json_object: '無効なJSONオブジェクト。',
    branding: {
        name: 'ブランディング',
        description: '組織レベルのサインイン体験をカスタマイズします。',
        organization_level_sie: '組織レベルのサインイン体験',
        organization_level_sie_switch: '組織レベルのサインイン体験を有効にし、組織固有のブランディングを設定します。無効の場合はアプリレベルのサインイン、続いて統合サインイン体験にフォールバックします。',
        logo: '組織ロゴ',
        logo_tooltip: '組織IDを渡してサインイン画面でこのロゴを表示できます。ダークモードが有効になっている場合は、ダークバージョンのロゴが必要です。<a>詳細</a>',
    },
    jit: {
        title: 'ジャストインタイムプロビジョニング',
        description: 'ユーザーは、いくつかの認証方法を使って初めてサインインするときに自動的に組織に参加し、役割が割り当てられます。ジャストインタイムプロビジョニングの要件を設定できます。',
        email_domain: 'メールドメインプロビジョニング',
        email_domain_description: '検証済みのメールアドレスでサインアップする新しいユーザー、または検証済みのメールアドレスを使ってソーシャルサインインする新しいユーザーは、自動的に組織に参加します。<a>詳細</a>',
        email_domain_placeholder: 'ジャストインタイムプロビジョニング用のメールドメインを入力',
        invalid_domain: '無効なドメイン',
        domain_already_added: '既に追加されたドメイン',
        sso_enabled_domain_warning: 'エンタープライズSSOに関連付けられたメールドメインを1つ以上入力しました。これらのメールを持つユーザーは標準的なSSOフローに従います。エンタープライズSSOプロビジョニングが設定されていない限り、この組織にプロビジョニングされません。',
        enterprise_sso: 'エンタープライズSSOプロビジョニング',
        no_enterprise_connector_set: 'エンタープライズSSOコネクタがまだ設定されていません。エンタープライズSSOプロビジョニングを有効にするには、まずコネクタを追加してください。<a>セットアップ</a>',
        add_enterprise_connector: 'エンタープライズコネクタを追加',
        enterprise_sso_description: 'エンタープライズSSOを使用して初めてサインインする新しいユーザーまたは既存のユーザーは、自動的に組織に参加します。<a>詳細</a>',
        organization_roles: 'デフォルトの組織ロール',
        organization_roles_description: 'ジャストインタイムプロビジョニングを通じて組織に参加したユーザーに役割を割り当てます。',
    },
    mfa: {
        title: '多要素認証 (MFA)',
        tip: 'MFAが必要な場合、MFAが設定されていないユーザーは組織トークンを取得しようとすると拒否されます。この設定はユーザー認証には影響しません。',
        description: 'この組織にアクセスするために必要な多要素認証を設定してください。',
        no_mfa_warning: 'テナントに多要素認証のメソッドが有効になっていません。少なくとも1つの<a>多要素認証メソッド</a>が有効になるまで、ユーザーはこの組織にアクセスできません。',
    },
};
export default Object.freeze(organization_details);
